import {
  CLIENT_FUND_SETTING_ADD_NEW,
  CLIENT_FUND_SETTING_ADD_NEW_SUCCESS,
  CLIENT_FUND_SETTING_ADD_NEW_ERROR,
  CLIENT_FUND_SETTING_DELETE,
  CLIENT_FUND_SETTING_DELETE_ERROR,
  CLIENT_FUND_SETTING_DELETE_SUCCESS,
  CLIENT_FUND_SETTING_EDIT,
  CLIENT_FUND_SETTING_EDIT_ERROR,
  CLIENT_FUND_SETTING_EDIT_SUCCESS,
  CLIENT_FUND_SETTING_GET_BY_ID,
  CLIENT_FUND_SETTING_GET_BY_ID_ERROR,
  CLIENT_FUND_SETTING_GET_BY_ID_SUCCESS,
  CLIENT_FUND_SETTING_GET_LIST,
  CLIENT_FUND_SETTING_GET_LIST_ERROR,
  CLIENT_FUND_SETTING_GET_LIST_SUCCESS,
  CLIENT_FUND_SETTING_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  clientFundSettings: [],
  clientFundSetting: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CLIENT_FUND_SETTING_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case CLIENT_FUND_SETTING_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        clientFundSetting: payload,
      };

    case CLIENT_FUND_SETTING_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case CLIENT_FUND_SETTING_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };

    case CLIENT_FUND_SETTING_GET_LIST_SUCCESS:
      return {
        ...state,
        clientFundSettings: payload,
        loading: true,
      };

    case CLIENT_FUND_SETTING_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case CLIENT_FUND_SETTING_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        clientFundSetting: payload,
        clientFundSettings: state.clientFundSettings.concat(payload),
        addSuccess: true,
      };

    case CLIENT_FUND_SETTING_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case CLIENT_FUND_SETTING_EDIT_SUCCESS:
      return {
        ...state,
        clientFundSettings: state.clientFundSettings.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        clientFundSetting: payload,
        error: null,
        loading: true,
        editSuccess: true,
      };

    case CLIENT_FUND_SETTING_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case CLIENT_FUND_SETTING_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        clientFundSettings: state.clientFundSettings.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case CLIENT_FUND_SETTING_DELETE_ERROR:
    case CLIENT_FUND_SETTING_ADD_NEW_ERROR:
    case CLIENT_FUND_SETTING_EDIT_ERROR:
    case CLIENT_FUND_SETTING_GET_BY_ID_ERROR:
    case CLIENT_FUND_SETTING_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
